import { Box, Button, Container, Divider, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import React from 'react'
import { Fade } from 'react-reveal'
import './Resume.css'
import CV from './MuhammadUsman.pdf'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { TimelineConnector, TimelineContent, TimelineSeparator, TimelineDot, TimelineItem, Timeline } from '@material-ui/lab'
import ProgressBar from '@ramonak/react-progress-bar';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div

      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};



const Resume = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box mt={12} id='Resume'>
        <Container  sx={{
          marginBottom: "8rem"

        }}>
          <Fade bottom>
            <Typography sx={{
              color: "#f9004d",
              letterSpacing: "1px",
              marginBottom: "10px",
              textTransform: "uppercase",
              fontSize: "14px",
              fontWeight: 500,
              fontFamily: "Montserrat, sans-serif",
              textAlign: "center",
            }}>
              6 month  experience
            </Typography>
          </Fade>

          <Fade bottom>
            <Typography component={'h1'} sx={{
              fontWeight: 700,
              fontSize: { md: "60px", xs: "30px" },
              color: "#c4cfde",
              fontFamily: "Montserrat, sans-serif",
              lineHeight: 1.2,

            }}>
              My Resume
            </Typography>
          </Fade>



          <Grid container>

            <Box mt={6} sx={{ width: '100%', }}>
              <div>


                <Tabs id='tabsname' value={value} onChange={handleChange} aria-label="basic tabs examplesss" className='usman'
                  TabIndicatorProps={{ sx: { display: 'none' } }}
                  sx={{
                    flexWrap: "wrap",
                    boxShadow: " 10px 10px 19px #1c1e22,-10px -10px 19px #262a2e",
                    borderRadius: "10px",
                    background: "linear-gradient(145deg,#1e2024,#23272b)",
                    textAlign: "center",
                    margin: "16px 0px",
                  }}>




                  <Tab sx={{ color: "#878e99", }} className='tabs tab1' value={0} label="Education" />
                  <Tab sx={{ color: "#878e99", }} className='tabs tab2' value={1} label="Professional Skills" />
                  <Tab sx={{ color: "#878e99", }} className='tabs tab1' value={2} label="Experience" />
                </Tabs>


              </div>
              <TabPanel value={value} index={0}>

                <Box>
                  <div>
                    <Typography sx={{
                      fontWeight: 700,
                      fontSize: { md: "36px", xs: "26px" },
                      lineHeight: "62px",
                      color: "#c4cfde",
                      marginBottom: "1.5rem"
                    }}>Education Quality</Typography>
                  </div>

                  <Box sx={{
                    padding: "55px 40px",
                    borderRadius: "6px",
                    background: "linear-gradient(145deg, #1e2024, #23272b)",
                    boxShadow: "10px 10px 19px #1c1e22, -10px -10px 19px #262a2e",
                    transition: "all 0.4s",
                    "&:hover": {
                      background: "linear-gradient(to right bottom, #212428, #16181c)",
                      animationDelay: "0.3s",

                    }

                  }}>

                    <Box sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #1a1d23",
                      paddingBottom: '20px',
                      marginBottom: "20px"
                    }}>

                      <Box sx={{
                        marginBottom: "15px"
                      }}>
                        <Typography className='h1-styling' sx={{
                          fontSize: { md: "24px", xs: "auto" }
                        }}>Bachelor of computer science</Typography>
                        <Typography className='span-styling' sx={{ fontSize: { md: "16px", xs: "14px" } }}>Government College University Faisalabad</Typography>
                      </Box>

                      <Box sx={{
                        display: "inline-block"
                      }}>
                        <span className='span-degree-styling'>2.94/4</span>
                      </Box>

                    </Box>
                    <Typography sx={{
                      fontSize: { md: "18px", xs: "14px" },
                      color: "#878e99",
                      transition: "0.4s",
                      textAlign: "left"
                    }}>I typically covered areas like computer programming, software engineering, computer hardware, and artificial intelligence engineering. Also I examined topics such as computability, information, automata, and algorithm design.</Typography>


                  </Box>

                </Box>

              </TabPanel>

              <TabPanel value={value} index={1}>
                <Box>



                  <div className="skill-box">
                    <span className="title">HTML</span>
                    <div className="skill-bar">
                      <span className="skill-per html">
                        <span className="tooltip">85%</span>
                      </span>
                    </div>
                  </div>
                  <div className="skill-box">
                    <span className="title">CSS</span>
                    <div className="skill-bar">
                      <span className="skill-per css">
                        <span className="tooltip">80%</span>
                      </span>
                    </div>
                  </div>
                  <div className="skill-box">
                    <span className="title">JavaScript</span>
                    <div className="skill-bar">
                      <span className="skill-per javascript">
                        <span className="tooltip">50%</span>
                      </span>
                    </div>
                  </div>
                  <div className="skill-box">
                    <span className="title">React JS</span>
                    <div className="skill-bar">
                      <span className="skill-per nodejs">
                        <span className="tooltip">50%</span>
                      </span>
                    </div>
                  </div>
                  <div className="skill-box">
                    <span className="title">React TS</span>
                    <div className="skill-bar">
                      <span className="skill-per reactjs">
                        <span className="tooltip">40%</span>
                      </span>
                    </div>
                  </div>
                  <div className="skill-box">
                    <span className="title">mui</span>
                    <div className="skill-bar">
                      <span className="skill-per mui">
                        <span className="tooltip">70%</span>
                      </span>
                    </div>
                  </div>
                  <div className="skill-box">
                    <span className="title">Flimora</span>
                    <div className="skill-bar">
                      <span className="skill-per mui">
                        <span className="tooltip">70%</span>
                      </span>
                    </div>
                  </div>


                </Box>
              </TabPanel>

              <TabPanel value={value} index={2}>

                <Box sx={{
                  padding: "55px 40px",
                  borderRadius: "6px",
                  background: "linear-gradient(145deg, #1e2024, #23272b)",
                  boxShadow: "10px 10px 19px #1c1e22, -10px -10px 19px #262a2e",
                  transition: "all 0.4s",
                  "&:hover": {
                    background: "linear-gradient(to right bottom, #212428, #16181c)",
                    animationDelay: "0.3s",

                  }

                }}>

                  <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #1a1d23",
                    paddingBottom: '20px',
                    marginBottom: "20px"
                  }}>

                    <Box sx={{
                      marginBottom: "15px"
                    }}>
                      <Typography component='h1' className='h1-styling' sx={{ fontSize: { md: "24px", xs: "auto" } }}>Bachelor of computer science</Typography>
                      <Typography className='span-styling' sx={{ fontSize: { md: "16px", xs: "14px" } }}>Government College University Faisalabad</Typography>
                    </Box>


                    <Box sx={{
                      display: "inline-block"
                    }}>
                      <span className='span-degree-styling' style={{ marginBottom: "1rem" }}>2.94/4</span>


                    </Box>

                  </Box>
                  <div>
                    <a href={CV} className='cv-btn' download="Usman Latif resume.pdf">Dowload my CV</a>
                  </div>
                  <Typography mt={3} sx={{
                    fontSize: { md: "18px", xs: "14px" },
                    color: "#878e99",
                    transition: "0.4s",
                    textAlign: "left"
                  }}>I typically covered areas like computer programming, software engineering, computer hardware, and artificial intelligence engineering. Also I examined topics such as computability, information, automata, and algorithm design.</Typography>


                </Box>

              </TabPanel>
            </Box>


          </Grid>

        </Container>
        <Divider sx={{
          maxWidth: "1270px",
          margin: "0 auto",
          background: "#121415",
          // marginTop:"6rem"
        }} />
      </Box>
    </>
  )
}

export default Resume